var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Notification',_vm._g({attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var retry = ref.retry;
var remove = ref.remove;
var cancel = ref.cancel;
return [(_vm.isNew || _vm.isInProgress)?[_c('progress-notification',{attrs:{"title":_vm.title}})]:(_vm.isDone)?[_c('done-notification',{attrs:{"title":_vm.title},on:{"remove":remove}})]:(_vm.isFail)?[_c('fail-notification',{attrs:{"title":_vm.title,"errorMessage":_vm.value.errorMessage},on:{"remove":remove,"cancel":cancel}})]:_vm._e()]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }